import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Filter, Main } from 'Containers';
import { NotificationDialog } from 'Components';
import { errorToast } from 'Common/ToastHelper';
import { resetForm } from 'State/forms/actions';
import { PHYSICAL_INVENTORY_FORM_NAME } from 'Common/FormEnum';
import {
  FilterOptionsEnum,
  GroupOptionsEnum,
} from 'Common/Constants/Enumeration/PhysicalInventoryReportEnum';
import {
  ReportTypeEnum,
  PrintSortTypeEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';
import * as SecuritySelectors from 'Common/Security/state/selectors';

import PhysicalInventoryReportComponent from '../components/PhysicalInventoryReport';
import {
  printReportData,
  clearPrintReportError,
} from './../../commonState/actions';
import * as CommonPrintSelector from '../../commonState/selectors';
import { includeOnHand } from '../helper';

class PhysicalInventoryReportContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    printLoading: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    filterByOptionsValue: PropTypes.number,
    sortByOptionsValue: PropTypes.number,
    groupByOptionsValue: PropTypes.number,
    printError: PropTypes.object,
    printData: PropTypes.string,
    preferences: PropTypes.array.isRequired,
  };

  static defaultProps = {
    filterByOptionsValue: 0,
    sortByOptionsValue: 0,
    groupByOptionsValue: 0,
    printError: null,
    printData: '',
  };

  static defaultProps = {
    filterByOptionsValue: 0,
    sortByOptionsValue: 0,
    groupByOptionsValue: 0,
    printError: null,
    printData: '',
  };

  reactTableRef = React.createRef();
  state = {
    showPrintMsg: false,
    selectedSortOption: PrintSortTypeEnum.ItemCode,
    selectedFilterOption: FilterOptionsEnum.OnHandItems,
    selectedGroupOption: GroupOptionsEnum.None,
    currentOnHand: true,
    selectedSites: [],
    activeIndexForFilter: 0,
    allSites: [],
  };

  componentDidUpdate(prevProps) {
    const { printData, clearPrintReportError } = this.props;
    if (errorToast(this.props, prevProps, 'printError')) {
      clearPrintReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Physical Inventory Report');
      clearPrintReportError();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.printReport,
            disabled: printLoading,
            loading: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  printReport = () => {
    const { selectedSites, allSites, currentOnHand } = this.state;
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: allSites };
    let sites = [];
    _.forEach(dataObjs.sortedData, obj => {
      if (obj._subRows) {
        const subRowSites = _.filter(
          obj._subRows,
          subObj => selectedSites.indexOf(subObj.Id) !== -1
        ).map(v => v.Id);
        sites = [...sites, ...subRowSites];
      } else {
        const id = obj.Id ? obj.Id : obj._original.Id;
        if (selectedSites.indexOf(id) !== -1) {
          sites.push(id);
        }
      }
    });
    if (sites.length) {
      const printObject = {
        ReportType: ReportTypeEnum.PhysicalInventoryReport,
        SortBy: this.state.selectedSortOption,
        FilterBy: this.state.selectedFilterOption,
        GroupBy: this.state.selectedGroupOption,
        IsIncludeCurrentOnHand: includeOnHand(
          currentOnHand,
          this.props.preferences
        ),
        SiteIds: sites,
      };
      this.props.printReportData(
        'PrintInventory/GetOrderOrPhysicalFormPrint',
        printObject
      );
    } else {
      this.setState({
        showPrintMsg: true,
      });
    }
  };

  setSelectedSites = selectedSites => {
    this.setState({ selectedSites: selectedSites });
  };

  handlePrintMsgDialog = () => {
    this.setState({
      showPrintMsg: false,
    });
  };

  setSortByOption = value => {
    this.setState({
      selectedSortOption: value,
    });
  };
  setFilterByOption = value => {
    this.setState({
      selectedFilterOption: value,
    });
  };
  setGroupByOption = value => {
    this.setState({
      selectedGroupOption: value,
    });
  };

  setCurrentOnHand = () => {
    this.setState({
      currentOnHand: !this.state.currentOnHand,
    });
  };

  clearFilters = () => {
    this.setState({
      selectedSortOption: PrintSortTypeEnum.ItemCode,
      selectedFilterOption: FilterOptionsEnum.OnHandItems,
      selectedGroupOption: GroupOptionsEnum.None,
      currentOnHand: true,
    });
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(PHYSICAL_INVENTORY_FORM_NAME);
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };
  getSitesCallback = allSites => {
    this.setState({ allSites });
  };

  render() {
    const {
      sortByOptionsValue,
      filterByOptionsValue,
      groupByOptionsValue,
    } = this.props;

    return (
      <Fragment>
        <Filter title={'Reports | Physical Form'} />
        <Main {...this.getMainProps()}>
          <PhysicalInventoryReportComponent
            sortOptionsValue={sortByOptionsValue}
            setSortByOption={this.setSortByOption}
            filterOptionsValue={filterByOptionsValue}
            setFilterByOption={this.setFilterByOption}
            groupOptionsValue={groupByOptionsValue}
            setGroupByOption={this.setGroupByOption}
            setCurrentOnHand={this.setCurrentOnHand}
            clearFilters={this.clearFilters}
            currentOnHand={this.state.currentOnHand}
            setSelectedSites={this.setSelectedSites}
            activeIndexForFilter={this.state.activeIndexForFilter}
            handleClick={this.handleClick}
            reactTableRef={this.reactTableRef}
            getSitesCallback={this.getSitesCallback}
          />
          <NotificationDialog
            title={'Physical Inventory Report'}
            showDialog={this.state.showPrintMsg}
            message={'You must select at least 1 site.'}
            onOkClick={this.handlePrintMsgDialog}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(PHYSICAL_INVENTORY_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(PHYSICAL_INVENTORY_FORM_NAME)(state));

  return {
    filterByOptionsValue: selector(state, FilterOptionsEnum.OnHandItems),
    sortByOptionsValue: selector(state, PrintSortTypeEnum.ItemCode),
    groupByOptionsValue: selector(state, GroupOptionsEnum.None),
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),

    initialValues: {
      SortOptions: PrintSortTypeEnum.ItemCode,
      FilterOptions: FilterOptionsEnum.OnHandItems,
      GroupOptions: GroupOptionsEnum.None,
      CurrentOnHand: true,
    },
    preferences: SecuritySelectors.getPreferences(state),
  };
};

const mapDispatchToProps = {
  resetForm,
  printReportData,
  clearPrintReportError,
};

PhysicalInventoryReportContainer = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: PHYSICAL_INVENTORY_FORM_NAME,
})(PhysicalInventoryReportContainer);

export const physicalinventoryreport = connect(
  mapStateToProps,
  mapDispatchToProps
)(PhysicalInventoryReportContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/physicalinventoryreport/containers/PhysicalInventoryReport.js